export default "__VITE_ASSET__Cu5YyDYW__"